import { colord } from "colord";

export interface GroupColors {
    backgroundColor: string;
    textColor: string;
}

export const MIN_HUE_DEGREES = 0;
export const MAX_HUE_DEGREES = 360;

// User picks the hue, and we set the lightness and saturation to ensure that the background and text
// color combinations are harmonic and meet the WCAG AA color contrast ratio requirements.
const BACKGROUND_LIGHTNESS_PERCENT = 85;
const BACKGROUND_SATURATION_FACTOR = 0.6;
const TEXT_LIGHTNESS_PERCENT = 25;

const SELECTED_COLOR_SATURATION_PERCENT = 100;
const SELECTED_COLOR_LIGHTNESS_PERCENT = 50;

export function getSelectedColor(hue: number): string {
    return colord({
        h: hue,
        s: SELECTED_COLOR_SATURATION_PERCENT,
        l: SELECTED_COLOR_LIGHTNESS_PERCENT,
    }).toHex();
}

export function deriveGroupColors(selectedColor: string): GroupColors {
    const { h, s } = colord(selectedColor).toHsl();
    const saturation = s * BACKGROUND_SATURATION_FACTOR;
    return {
        backgroundColor: colord({ h, s: saturation, l: BACKGROUND_LIGHTNESS_PERCENT }).toHex(),
        textColor: colord({ h, s: saturation, l: TEXT_LIGHTNESS_PERCENT }).toHex(),
    };
}

export function getHue(color: string): number {
    return Math.round(colord(color).toHsl().h);
}
